import React from 'react';
import { Link } from 'react-router-dom';

export default () => {
  return (
    <header class="header_area">
      <div class="main_menu">
        <nav class="navbar navbar-expand-lg navbar-light">
          <div class="container box_1620">
            {/* Brand and toggle get grouped for better mobile display */}
            <Link class="navbar-brand logo_h" to="/">
              <img src={require('../img/logo.png')} alt="" />
            </Link>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>

            {/* Collect the nav links, forms, and other content for toggling */}
            <div class="collapse navbar-collapse offset" id="navbarSupportedContent">
              <ul class="nav navbar-nav menu_nav ml-auto">
                <li class="nav-item"><Link class="nav-link" to="/">Início</Link></li>
                <li class="nav-item"><Link class="nav-link" to="/contato">Contato</Link></li>
              </ul>
              <ul class="nav navbar-nav navbar-right">
                <li class="nav-item"><a href="#" class="search"><i class="lnr lnr-magnifier" /></a></li>
              </ul>
            </div> 
          </div>
        </nav>
      </div>
    </header>
  )
}
